"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.naivelyParseExistingParams = exports.replaceQueryParams = exports.createUrlParamStore = void 0;
var qs_1 = __importDefault(require("qs"));
var createUrlParamStore = function () {
    var urlParamStore = {
        getFilter: function (namespace) {
            var parsed = naivelyParseExistingParams();
            var parsedInfo = parsed["info." + namespace];
            var parsedFilter = parsed["filter." + namespace];
            // useFilter doesn't really support returning a partial FilterInfo, so both
            // need to be present,
            if (parsedInfo || parsedFilter) {
                var _a = parsedInfo || {}, page = _a.page, offset = _a.offset, pageSize = _a.pageSize, rest = __rest(_a, ["page", "offset", "pageSize"]);
                return __assign(__assign({}, __assign({ page: 1 / page ? +page : undefined, pageSize: 1 / pageSize ? +pageSize : undefined, offset: 1 / offset ? +offset : undefined }, rest)), { filter: parsedFilter });
            }
        },
        saveFilter: function (namespace, filterInfo) {
            var parsed = naivelyParseExistingParams();
            // Setting the params to the equivalent of { [namespace]: filterInfo }
            // takes up more room. The idea is that this ...
            //     'filter.filterName%5BfilterValueKey%5D=filterValueValue'
            // ... is smaller than ...
            //     filterName%5Bfilter%5D%5BfilterValueKey%5D=filterValueValue
            // ... by 5 characters per value in a filter. So excuse us for a second ...
            var clonedInfo = __assign({}, filterInfo);
            var clonedFilter = filterInfo.filter;
            delete clonedInfo.filter;
            delete clonedInfo.lastRefreshAt;
            delete clonedInfo.shouldRunImmediately;
            delete clonedInfo.totalResults;
            delete clonedInfo.totalPages;
            delete clonedInfo.nextCursor;
            parsed["filter." + namespace] = clonedFilter;
            parsed["info." + namespace] = clonedInfo;
            replaceQueryParams(qs_1.default.stringify(parsed));
        },
        clear: function () {
            var parsed = naivelyParseExistingParams();
            for (var key in parsed) {
                if (key.startsWith('filter.') || key.startsWith('info.')) {
                    delete parsed[key];
                }
            }
            replaceQueryParams(qs_1.default.stringify(parsed));
        },
        getData: function () {
            return undefined;
        },
        saveData: function () { },
    };
    return urlParamStore;
};
exports.createUrlParamStore = createUrlParamStore;
function replaceQueryParams(newParams) {
    var nextUrl = new URL(window.location.toString());
    nextUrl.search = newParams;
    window.history.replaceState(undefined, '', nextUrl.toString());
}
exports.replaceQueryParams = replaceQueryParams;
function naivelyParseExistingParams() {
    // Don't really want to do any casting, especially not to `any`, but the type
    // of `qs.parse` is so wide we'd have to litter checks all over the place.
    return qs_1.default.parse(window.location.search.substring(1));
}
exports.naivelyParseExistingParams = naivelyParseExistingParams;
